import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CancelComponent,
  FeedbackSurveyComponent,
  LayoutDefaultComponent,
  ProgressHeaderComponent,
} from '@shared/components';
import { FooterNavComponent } from '@shared/components/footer-nav/footer-nav.component';
import { ButtonModule } from '@vg-constellation/angular-16/button';
import { ProgressBarComponent } from '@vg-constellation/angular-18/progress-bar';
import { VgimCommonModule, VgimPersonalAddressModule } from 'vg-interaction-model';

import { ContactInfoRoutingModule } from './contact-info-routing.module';
import { ContactInfoComponent } from './containers/contact-info.component';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ContactInfoRoutingModule,
    ReactiveFormsModule,
    VgimPersonalAddressModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
    VgimCommonModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
    ReactiveFormsModule,
    CancelComponent,
    FeedbackSurveyComponent,
    LayoutDefaultComponent,
    ProgressBarComponent,
    ProgressHeaderComponent,
    FooterNavComponent,
  ],
  declarations: [ContactInfoComponent],
  exports: [ContactInfoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactInfoModule {}
